export enum SongChapterType {
  Tabs = "tabs",
  Chords = "chords",
  Lyrics = "lyrics",
}

export type SongChapterTypeValue = `${SongChapterType}`;

export enum UserTypes {
  User = 0,
  Moderator = 1,
  Admin = 2,
  SuperAdmin = 3,
  President = 4,
  Master = 5,
}

export enum Months {
  January = 0,
  February = 1,
  March = 2,
  April = 3,
  May = 4,
  June = 5,
  July = 6,
  August = 7,
  September = 8,
  October = 9,
  November = 10,
  December = 11,
}

export enum ScreenBreakpoints {
  Mobile = 640,
  Tablet = 1080,
  Desktop = 1920,
  Ultrawide = 3000,
}
